import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  instanceList: any;
  instanceListTarget: any;
  selectedInstance: any;
  targetInstance: any;
  batchKey: string;
  public tracks = [];
  public configData = [];
  showArray = [];
  public itemNumber = 0;
  instanceListDuplicate: any;
  dynamicVariable = true;
  selectedValue: string;
  public sourceVal = [];
  selOpt: boolean = true;

  public progressBarName = 'select';

  public progressBarArray1 = [{ name: "select", src: 'assets/select.png', index: 0 },
  { name: "submit", src: 'assets/submit.png', index: 1 },
  { name: "compare", src: 'assets/Vector.png', index: 2 },
  ];
  instanceVariable = null;


  constructor(
    public dialog: MatDialog,
    private compareService: CompareserviceService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.compareService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.getConfigDetails(DconConfigAPI.API_VARIABLES.Request_Type_Compare);
      this.getInstanceDetails(DconConfigAPI.API_VARIABLES.CLOUD);
      this.selectedInstance = null;
      this.targetInstance = null;
      this.batchKey = this.compareService.batchKey;
    }
  }

  getHomePage() {
    this.router.navigate(["select"], { relativeTo: this.route });
  }

  onInstanceChangeAtSource(instance) {
    if (instance == null) {
      this.targetInstance = null;
      this.instanceListTarget = this.instanceListDuplicate;
      this.dynamicVariable = true;
    } else {
      this.dynamicVariable = false;
      this.instanceListTarget = this.instanceListDuplicate.filter(
        i => i.INSTANCE !== instance.INSTANCE);
      if (this.selectedInstance?.INSTANCE === this.targetInstance?.INSTANCE) {
        this.targetInstance = null;
      }
    }
  }

  onInstanceChangeAtTarget(instance) {

  }

  configPopUp(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.compareService.sourceInstance = this.selectedInstance;
      this.compareService.targetInstance = this.targetInstance;
      this.compareService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configData);
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        this.compareService.tabval.next("submit");
        this.router.navigate(["../submit"], { relativeTo: this.route });
      } else {
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK === element.TRACK && selConfigData.APPLICATION_SHORT_CODE === element.APPLICATION_SHORT_CODE) {
        selConfigData.saveStatus = true;
        this.configData.splice(index, 1, selConfigData);
      }
    });

  }

  getInstanceDetails(type) {

    const data = [];
    this.compareService.getInstanceDetails(type).subscribe((res) => {
      res?.Instance_Details?.forEach((element) => {
        data.push(JSON.parse(element.details));
      });
      this.instanceList = data[0].INSTANCE;

      this.instanceListDuplicate = data[0].INSTANCE;
      this.instanceListTarget = data[0].INSTANCE;
      this.compareService.selectInstanceListTarget = this.instanceListTarget;
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }

  getConfigDetails(type) {
    const data = [];
    this.compareService.getConfigDetails(type).subscribe((res) => {
      res?.Config_Details?.forEach((element) => {
        let task = [];
        const obj = JSON.parse(element.details);
        if (obj.TASK != null) {
          obj.TASK.forEach((ele) => {
            const taskObj = ele;
            taskObj["selectStatus"] = "n";
            task.push(taskObj);
          });
        } else {
          task = null;
        }
        const detailsObj = {
          TRACK: obj.TRACK,
          APPLICATION: obj.APPLICATION,
          APPLICATION_SHORT_CODE: obj.APPLICATION_SHORT_CODE,
          saveStatus: false,
          TASK: task,
        };
        data.push(detailsObj);
      });
      this.configData = data;
      data.forEach((element, index) => {
        this.tracks.push(element.TRACK);
        this.showArray[index] = false;
      });
      this.tracks = [...new Set(this.tracks)];
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }
}
